import $ from "jquery"; // the page's jQuery, see `externals` in webpack.mix.js
import 'slick-carousel';

$(window).scroll(function (e) {
    landinglogo();
    $(".animazione.ferma.landing-lancio").each(function (index, element) {
        animaBoxScrolllandinglancio(element);
    });
    if ($(".riga-img-scroll").length) {
        gestisciRigaImmaginiScroll(e);
    }

    var window_top = $(window).scrollTop();
    var div_top = $('.content-page').offset().top;


    if(window_top > div_top){
        $('.submit-container').addClass('submitFixed');
    } else {
        $('.submit-container').removeClass('submitFixed');
    }
});

$('.submitFixed').on("click",function(){
    $(window).scrollTop(0);
});

$(".animazione.ferma.landing-lancio").each(function (index, element) {
    animaBoxScrolllandinglancio(element);
});

window.addEventListener("resize", function () {
    jQuery(".animazione.ferma.landing-lancio").each(function (index, element) {
        animaBoxScrolllandinglancio(element);
    });
});

function landinglogo() {

    let heroheight = $(".hero.landing").height();

    if (heroheight) {
        $(".logo").removeClass("d-none");


        let wS = jQuery(window).scrollTop();

        if (wS > heroheight) {
            $(".logo").removeClass("nascosto");
        } else {
            $(".logo").addClass("nascosto");
        }
    }
}

function animaBoxScrolllandinglancio(element) {
    const container = jQuery(element);
    const panelcontainer = container.find('.container-animazione');

    let hT = container.offset().top,
        hH = container.outerHeight(),
        wS = jQuery(window).scrollTop();

    let header_height = 0;

//0%
    if ((wS + header_height) <= Math.round(hT)) {


        panelcontainer.css('top', '0px');
        panelcontainer.css('position', 'relative');
    }

    if (((wS + header_height) > Math.round(hT)) && ((wS + header_height) < (hT + hH))) {
        panelcontainer.css('top', '0px');
        panelcontainer.css('position', 'fixed');


    }

//100%
    if ((wS + header_height) >= (Math.round(hT) + (Math.round(hH) / 3))) {
        panelcontainer.css('top', (Math.round(hH) / 3) + 'px');
        panelcontainer.css('position', 'relative');
    }
}

function gestisciRigaImmaginiScroll(e) {

    let wH = jQuery(window).height(),
        wW = jQuery(window).width(),
        wS = jQuery(window).scrollTop(),
        header_height = 0; //nelle landing con questo componente non c'è sticky header

    if (wW > 1199) {
        jQuery(".riga-img-scroll").each(function (index) {

            let riga = jQuery(this);
            let hT = riga.offset().top,
                hH = riga.outerHeight();


            if ((wS + header_height) < Math.round(hT)) {
                //prima che la riga arrivi in alto contando lo sticky header
                riga.find('.content-testo .row').removeClass('blocked');
                riga.find('.content-testo').removeClass('allinea-basso');

                riga.find('.content-testo').addClass('allinea-alto');
                //console.log(index+ ": alto");
            } else if ((wS + wH) > (Math.round(hT) + Math.round(hH))) {
                //quando la riga finisce
                riga.find('.content-testo .row').removeClass('blocked');
                riga.find('.content-testo').removeClass('allinea-alto');

                riga.find('.content-testo').addClass('allinea-basso');
                //console.log(index+ ": basso");

            } else {
                //sto scrollando la riga
                riga.find('.content-testo').removeClass('allinea-basso');
                riga.find('.content-testo').removeClass('allinea-alto');

                riga.find('.content-testo .row').addClass('blocked');
                //console.log(index+ ": blocked");
            }


        });
    }
}
